export function folderNameError(value){
 const name=value==null?'':String(value)
 return name.trim()&&/^[^/\\\x00-\x1f\x7f]{1,255}$/.test(name)&&name!=='.'&&name!=='..'&&!name.endsWith('.')
  ?true:'请输入有效目录名称（1至255字，不能包含斜线、控制字符或以点结尾）'
}

export default {
 data:()=>({folderCreating:false}),
 methods:{
  showBlankMenu(event){
   if(event.defaultPrevented||!event.target||!this.$el.contains(event.target))return
   if(event.target.closest('input,textarea,button,a,select,[contenteditable="true"],.drive-context,.el-table__row,.drive-grid-card,.drive-column-row,.drive-toolbar,.drive-heading,.drive-tabs,.drive-uploads,.el-pagination,.el-table__header-wrapper,.el-dialog,.el-message-box'))return
   event.preventDefault();this.contextMenu=null
   if(this.mode!=='files'||this.loading||this.locating||this.folderCreating)return
   const element=event.target.closest('.drive-column'),column=element&&this.columns[Number(element.getAttribute('data-drive-column'))]
   this.contextMenu={blank:true,parentId:column&&column.tree?column.parentId:this.parentId,owner:this.columnOwner(),
    x:Math.max(8,Math.min(event.clientX,window.innerWidth-205)),y:Math.max(8,Math.min(event.clientY,window.innerHeight-60))}
  },
  newFolderFromMenu(){
   const menu=this.contextMenu;this.contextMenu=null
   if(!menu||!menu.blank||menu.owner!==this.columnOwner())return
   return this.newFolder(menu.parentId,menu.owner)
  },
  async newFolder(parentId=this.parentId,owner=this.columnOwner()){
   if(this.folderCreating||this.mode!=='files')return
   const current=()=>!this.disposed&&owner===this.columnOwner()
   if(!current())return
   this.folderCreating=true
   try{
    const {value}=await this.$prompt('请输入目录名称','新建目录',{inputValue:'',inputValidator:folderNameError,confirmButtonText:'创建',cancelButtonText:'取消',closeOnClickModal:false})
    if(!current()||this.mode!=='files')return
    const valid=folderNameError(value)
    if(valid!==true)throw Error(valid)
    const generation=this.generation,id=await this.request('/folders',{parentId,name:value},'POST')
    if(!current())return
    this.$message.success('目录已创建')
    // Follow the newly created directory in the existing view, unless the user navigated away.
    if(generation===this.generation)await this.revealInDrive({id,parentId,name:value,kind:'DIR'})
   }catch(error){if(current())this.report(error)}
   finally{this.folderCreating=false}
  }
 }
}
